import { render, staticRenderFns } from "./GoodsDetailsDialog.vue?vue&type=template&id=fa830dec&scoped=true&"
import script from "./GoodsDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./GoodsDetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./GoodsDetailsDialog.vue?vue&type=style&index=0&id=fa830dec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa830dec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa830dec')) {
      api.createRecord('fa830dec', component.options)
    } else {
      api.reload('fa830dec', component.options)
    }
    module.hot.accept("./GoodsDetailsDialog.vue?vue&type=template&id=fa830dec&scoped=true&", function () {
      api.rerender('fa830dec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/components/GoodsDetailsDialog.vue"
export default component.exports